import axios from "axios";


const baseURL = import.meta.env.VITE_API_BASE_URL as string;
export const ONBOARDING_ACCESS_TOKEN_KEY = "onboarding_access_token";

export const getOnboardingAccessToken = () =>
  sessionStorage.getItem(ONBOARDING_ACCESS_TOKEN_KEY);

export const setOnboardingAccessToken = (token: string) => {
  sessionStorage.setItem(ONBOARDING_ACCESS_TOKEN_KEY, token);
};

export const clearOnboardingAccessToken = () => {
  sessionStorage.removeItem(ONBOARDING_ACCESS_TOKEN_KEY);
};

export const accountDocumentUrl = (file: string, token: string) => {
  if (file.startsWith('http') && !file.includes('/v1/files/')) return file;
  const filename = (file.split('/v1/files/')[1] || file).replace(/^accounts\//, '').split('?')[0];
  return `${baseURL}/v1/files/accounts/${encodeURIComponent(filename)}?token=${encodeURIComponent(token)}`;
};

export const api = axios.create({
  baseURL: `${baseURL}/v1`,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

// -----------------------------------------

export const serverPulseCheck = async () => {
  try {
    const res = await api.get("health-check");
    import.meta.env.DEV && console.log("Server status:", res.status);
  } catch (error) {
    // showErrorNotification({ title: "oops", message: "unable-to-reach-server" });
    import.meta.env.DEV && console.error("[Server Pulse Check]", error);
  }
};
